import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UnifiedKYCPage from './pages/UnifiedKYCPage';
import AboutPage from './pages/AboutPage';
import UseCasesPage from './pages/UseCasesPage';
import ContactPage from './pages/ContactPage';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('kycshield_token');
  return token ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/use-cases" element={<UseCasesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/dashboard" element={
          <PrivateRoute>
            <DashboardPage />
          </PrivateRoute>
        } />
        <Route path="/unified" element={
          <PrivateRoute>
            <UnifiedKYCPage />
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
